import $ from 'jquery';
import favorites from '../favorites/favorites';

window.addEventListener('px-ready',function(){
    
    $('body').on('click', '.px-product-list .likecontainer', function(){
        var tthis = $(this);
        if(tthis.parent().attr('data-lock') != 1){
            tthis.parent().attr('data-lock',1);
            window.setTimeout(function(){tthis.parent().attr('data-lock',0);},100);
            var $parent = tthis.parent(), id = $parent.data('id');
            if ($parent.hasClass('is-liked')) {
                favorites.remove(id);
                $parent.removeClass('is-liked');
            } else {
                favorites.add(id);
                $parent.addClass('is-liked');
            }
        }
    })
    $('body').on('click', '.px-product-list td:not(.likecontainer)',function(e){
        //$(this).parent().find('a.link').trigger('click');
        console.log('x '+ $(this).parent().find('a.link').attr('href'))
        window.location.href = $(this).parent().find('a.link').attr('href');
    })
})
